module.exports = __webpack_public_path__ + "img/BASEBALL CAP PURPLE.9fd1b52.svg";